module.exports = __webpack_public_path__ + "static/img/img_review4.a2e7a70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile_barocare/img_review4.png
// module id = 5scK
// module chunks = 0